// This is due to Mapbox not accepting id:s with other characters than numbers.
// When updating mapbox-gl, this extension might not be necessary.
String.prototype.toMapboxId = function () {
  let hash = 0
  for (let i = 0; i < this.length; i++) {
    let character = this.charCodeAt(i)
    hash = (hash << 5) - hash + character
    hash = hash & hash // Convert to 32bit integer
  }
  return 2147483648 + hash + ''
}
